'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["editor", "target", "onSrcChange", "onAltTextChange", "onLoadingValueChange", "onImageRemove", "omitDomainRewriteAttr"];
import PropTypes from 'prop-types';
import ImagePopoverBodyBranch from 'rich-text-lib/components/image/ImagePopoverBodyBranch';
import withLinkControl from './withLinkControl';
import { adaptLinkPropsToAttr, updateLinkInfo } from '../utils/link';
import { jsx as _jsx } from "react/jsx-runtime";
const EnhancedImagePopoverBodyBranch = withLinkControl(ImagePopoverBodyBranch);
const propTypes = {
  editor: PropTypes.object.isRequired,
  target: PropTypes.exact(HTMLImageElement),
  altText: PropTypes.string,
  loadingValue: PropTypes.string,
  onSrcChange: PropTypes.func.isRequired,
  onAltTextChange: PropTypes.func.isRequired,
  onLoadingValueChange: PropTypes.func.isRequired,
  onImageRemove: PropTypes.func.isRequired
};
function ImagePopover(props) {
  const {
      editor,
      target,
      onSrcChange,
      onAltTextChange,
      onLoadingValueChange,
      onImageRemove,
      omitDomainRewriteAttr
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleSave = (linkInfo, updatedImageAttrs = {}) => {
    const linkOptions = adaptLinkPropsToAttr(linkInfo, {
      omitDomainRewriteAttr
    });
    updateLinkInfo(editor, target, linkOptions);
    const {
      altText: updatedAltText,
      loadingValue: updatedLoadingValue
    } = updatedImageAttrs;
    if (typeof updatedAltText === 'string' && updatedAltText !== props.altText) {
      onAltTextChange(target, updatedAltText);
    }
    if (updatedLoadingValue !== props.loadingValue) {
      onLoadingValueChange(target, updatedLoadingValue);
    }
  };
  return /*#__PURE__*/_jsx(EnhancedImagePopoverBodyBranch, Object.assign({}, rest, {
    editor: editor,
    target: target,
    onSave: handleSave,
    onReplace: onSrcChange.bind(null, target),
    onImageRemove: onImageRemove.bind(null, target),
    dropdownClassName: "mce-ui-select",
    tooltipClassName: "mce-image-tooltip",
    useNoLinkOption: true
  }));
}
ImagePopover.propTypes = propTypes;
ImagePopover.displayName = 'ImagePopover';
export default ImagePopover;